export default __webpack_public_path__ + "static/assets/med_pill_square_in_L2_solid_x_01_f_mask.3d07b734.png";